/**
 * 主菜单与角色菜单权限。
 *
 * 菜单 key 与后端 app/services/role_service.py 的 KNOWN_MENUS 保持一致，
 * 判定规则需与 user_has_menu 同步修改。
 */

export const MAIN_MENUS = [
  { key: 'home', title: '首页', icon: 'mdi-home', path: '/ins' },
  { key: 'data_import', title: '数据导入', icon: 'mdi-database', path: '/data-import' },
  { key: 'insure_apply', title: '投保申请', icon: 'mdi-file-document-edit', path: '/insure-apply' },
  { key: 'policy_list', title: '保单查看', icon: 'mdi-file-eye', path: '/policy-list' },
  { key: 'insurance_results', title: '投保成果展示', icon: 'mdi-monitor-dashboard', path: '/insurance-results' },
  { key: 'claim', title: '农情展示', icon: 'mdi-sprout', path: '/claim' },
  { key: 'dashboard', title: '数据统计', icon: 'mdi-chart-bar', path: '/dashboard' }
]

export const KNOWN_MENU_KEYS = MAIN_MENUS.map(item => item.key)

/**
 * 判断角色是否有某个菜单。
 * - role 缺失（未配置角色）时不限制，保证存量账号不被误锁；
 * - modules 含 'all' 时放行；
 * - modules 与已知菜单 key 无交集视为旧词表，同样不限制。
 */
export function menuAllowedByRole (role, menuKey) {
  if (!role) return true
  const modules = Array.isArray(role.modules) ? role.modules : []
  if (modules.includes('all')) return true
  const declared = modules.filter(item => KNOWN_MENU_KEYS.includes(item))
  if (!declared.length) return true
  return declared.includes(menuKey)
}

/** 按角色过滤菜单，保持 MAIN_MENUS 的顺序。 */
export function menusForRole (role) {
  return MAIN_MENUS.filter(item => menuAllowedByRole(role, item.key))
}
